import { IIdName } from '@/interfaces/general/IIdName.ts';

const zoneOptions: Array<IIdName> = [
    {
        id: 'All Zones', name: 'All Zones',
    },
    {
        id: 'Z1', name: 'Z1',
    },
    {
        id: 'Z2', name: 'Z2',
    },
    {
        id: 'Z3', name: 'Z3',
    },
    {
        id: 'Z4', name: 'Z4',
    },
    {
        id: 'Z5', name: 'Z5',
    },
    {
        id: 'Z6', name: 'Z6',
    },
    {
        id: 'Z7', name: 'Z7',
    },
    {
        id: 'Z8', name: 'Z8',
    },
    {
        id: 'Z9', name: 'Z9',
    },
    {
        id: 'Z10', name: 'Z10',
    },
    {
        id: 'Z11', name: 'Z11',
    },
    {
        id: 'Z12', name: 'Z12',
    },
    {
        id: 'Z13', name: 'Z13',
    },
    {
        id: 'Z14', name: 'Z14',
    },
    {
        id: 'Z15', name: 'Z15',
    },
    {
        id: 'Z16', name: 'Z16',
    },
    {
        id: 'Z17', name: 'Z17',
    },
];

export {
    zoneOptions,
};
